import React, { useEffect } from 'react';

// TBD: refactor the (boolean | number) logic for opened levels.
export const useScrollTop = (ref: React.RefObject<HTMLElement>, open: boolean | number) => {
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (open) {
      return;
    }

    const el = ref.current;
    const scrollTopWithTimer = setTimeout(() => (el.scrollTop = 0), 150);

    return () => {
      clearTimeout(scrollTopWithTimer);
    };
  }, [open, ref]);
};
